import axios from "axios";
import { API_CONFIG } from "../config/api.config";

const API_URL = API_CONFIG.BASE_URL;

// 调试信息 - 在开发环境下显示API配置
if (process.env.NODE_ENV === "development") {
  console.log("🔧 API配置信息:");
  console.log("  REACT_APP_API_URL:", process.env.REACT_APP_API_URL);
  console.log("  实际使用的API_URL:", API_URL);
}

// API error class
export class ApiError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.status = status;
    this.name = "ApiError";
  }
}

// Get token from localStorage
// 优先读取运营端专用 admin_token，其次回退读取通用 token
export const getToken = (): string | null => {
  return localStorage.getItem("admin_token") || null;
};

// Authentication handling
// TODO: 重新打开
export const handleAuthError = () => {
  // // 清理运营端和通用 token 信息
  // localStorage.removeItem("admin_token");
  // localStorage.removeItem("admin_user");
  // // Redirect to login page if needed
  // if (window.location.pathname !== "/login") {
  //   window.location.href = "/login";
  // }
};

// Generic API request with authentication
export const apiRequest = async <T>(
  endpoint: string,
  method: string = "GET",
  data: any = null,
  requiresAuth: boolean = true,
  options: any = {}
): Promise<T> => {
  const url = `${API_URL}${endpoint}`;

  // 开发环境下输出请求信息
  if (process.env.NODE_ENV === "development") {
    console.log(`🌐 API请求: ${method} ${url}`);
  }

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  // Add token if authentication is required
  if (requiresAuth) {
    const token = getToken();
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    } else {
      // No token available but authentication required
      handleAuthError();
      throw new ApiError("认证已过期，请重新登录", 401);
    }
  }

  try {
    const response = await axios({
      url,
      method,
      headers,
      data: method !== "GET" && method !== "DELETE" ? data : undefined,
      params: method === "GET" ? data : undefined,
      ...options,
    });

    return response.data;
  } catch (error: any) {
    // Handle authentication errors
    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403)
    ) {
      handleAuthError();
    }

    throw new ApiError(
      error.response?.data?.message || "请求失败",
      error.response?.status || 500
    );
  }
};

// Format query params
export const formatQueryParams = (params: Record<string, any>): string => {
  const queryParts: string[] = [];

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return; // Skip empty values
    }

    if (Array.isArray(value)) {
      // 处理数组参数，每个值生成一个单独的查询参数，使用相同的key
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== "") {
          queryParts.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(item)}`
          );
        }
      });
    } else {
      // 处理普通参数
      queryParts.push(
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      );
    }
  });

  return queryParts.length ? `?${queryParts.join("&")}` : "";
};
